import React from 'react'
import clsx from 'clsx'

import useBaseStyles from '../styles'
import useStyles from './styles'
import useCustomFieldFlows from '@SonarCX/hooks/useCustomFieldFlows'
import { CloseCircle } from 'iconsax-react'
import { useTheme } from '@mui/material'

type FlowFieldEntryProps = {
  state: APICustomField
  setState: React.Dispatch<React.SetStateAction<APICustomField>>
}
const FlowFieldEntry: React.FC<FlowFieldEntryProps> = ({ state, setState }) => {
  const theme = useTheme()
  const { allFlows: flows } = useCustomFieldFlows(state.object_type)

  const [search, setSearch] = React.useState('')
  const fields = React.useMemo(() => {
    const query = search.toLocaleLowerCase().trim()
    const searchResults = flows.filter(
      field =>
        field.title.toLocaleLowerCase().includes(query) ||
        field.description?.toLocaleLowerCase().includes(query)
    )

    return searchResults
  }, [flows, search])

  const selectedFlow = state.config?.id
    ? flows.find(f => f.id === state.config.id)
    : null

  const baseClasses = useBaseStyles()
  const classes = useStyles()

  const handleRemove = React.useCallback(() => {
    setState(old => ({
      ...old,
      config: null
    }))
  }, [setState])

  const handleSelect = React.useCallback(
    (field: APIFlow) => {
      setState(old => ({
        ...old,
        config: { id: field.id, options: [] }
      }))
    },
    [setState]
  )

  return (
    <div className={clsx(baseClasses.row, baseClasses.column)}>
      <div className={baseClasses.label}>Configuration</div>

      {selectedFlow && (
        <div className={classes.selected}>
          <div>
            <div className={baseClasses.label}>{selectedFlow.title}</div>
            {selectedFlow.description && (
              <small>{selectedFlow.description}</small>
            )}
          </div>
          <CloseCircle
            color={theme.palette.primary.main}
            size={theme.size.base}
            className={classes.selectedAction}
            onClick={handleRemove}
          />
        </div>
      )}

      {!selectedFlow && (
        <>
          <input
            placeholder='Search flows'
            value={search}
            onChange={e => setSearch(e.target.value)}
            className={baseClasses.input}
            style={{ marginTop: '0.25rem' }}
          />
          <div className={classes.fields}>
            {fields.length === 0 ? (
              <div>No flows</div>
            ) : (
              <>
                {fields.map(field => (
                  <div
                    key={field.id}
                    className={classes.field}
                    onClick={() => handleSelect(field)}
                  >
                    <div key={field.id}>{field.title}</div>
                    {field.description && <small>{field.description}</small>}
                  </div>
                ))}
              </>
            )}
          </div>
        </>
      )}
    </div>
  )
}

export default FlowFieldEntry
